import React from 'react';
import type { WeatherState } from '../types/weather';
import { WeatherIcon } from './WeatherIcon';

export const WeatherWidget: React.FC<{ weather: WeatherState }> = ({ weather }) => {
    return (
        <div className="weatherWidget" aria-label="Aktuální počasí v Drage">
            <div className="weatherIcon"><WeatherIcon code={weather.weatherCode} /></div>
            <div className="weatherText">
                <div className="weatherPlace">{weather.locationLabel}</div>
                <div className="weatherTemp">{weather.temperatureC}°C</div>
            </div>
        </div>
    );
};
